import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Shop from "../pages/shop/page";
import Product from "../pages/product/page";
import ContentPage from "../pages/content/page";
import LoginPage from "../pages/login/page";
import RegisterPage from "../pages/register/page";
import AccountPage from "../pages/account/page";
import TrackOrderPage from "../pages/track-order/page";
import PaymentPage from "../pages/payment/page";
import PaymentSuccessPage from "../pages/payment/PaymentSuccess";
import PaymentFailPage from "../pages/payment/PaymentFail";
import Checkout from "../pages/checkout/page";
import WishlistPage from "../pages/wishlist/page";
import Layout from "../components/feature/Layout";

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/shop", element: <Shop /> },
      { path: "/product/:id", element: <Product /> },
      { path: "/page/:slug", element: <ContentPage /> },
      { path: "/checkout", element: <Checkout /> },
      { path: "/wishlist", element: <WishlistPage /> },
      { path: "/login", element: <LoginPage /> },
      { path: "/register", element: <RegisterPage /> },
      { path: "/account", element: <AccountPage /> },
      { path: "/track-order", element: <TrackOrderPage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
  // Standalone pages (no header/footer)
  { path: "/payment/:token", element: <PaymentPage /> },
  { path: "/payment-success", element: <PaymentSuccessPage /> },
  { path: "/payment-fail", element: <PaymentFailPage /> },
];

export default routes;
